import { render, staticRenderFns } from "./PortalProgressStep.vue?vue&type=template&id=a5ba9562"
import script from "./PortalProgressStep.vue?vue&type=script&lang=js"
export * from "./PortalProgressStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports